import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './header.css';
import logo from '../asset/logo/logo192.png';

function Header({ variant = 'default' }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '/assistant';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const NavContent = () => {
    const prefix = variant === 'assistant' ? '/assistant' : '';

    return (
      <>
        {!isHomePage && (
          <Link to={variant === 'assistant' ? "/assistant" : "/"}>Home</Link>
        )}
        <Link to={`${prefix}/interview-copilot`}>Interview Copilot</Link>
        <Link to={`${prefix}/coding-assistant`}>Coding Assistant</Link>
        <Link to={`${prefix}/pricing`}>Pricing</Link>
        {isHomePage && (
          <>
            <Link to={`${prefix}/testimonials`}>Testimonials</Link>
            <Link to={`${prefix}/faqs`}>FAQs</Link>
          </>
        )}
        {variant !== 'assistant' && (
          <>
            <Link to="/blog/guide-to-features">Features Guide</Link>
            <Link to="/blog/ethics">Ethics</Link>
          </>
        )}
        <Link to={`${prefix}/contact`}>Contact</Link>
      </>
    );
  };

  return (
    <header className="header">
      <div className="logo-container">
        <Link to={variant === 'assistant' ? "/assistant" : "/"} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img src={logo} alt="ConvoCue AI Logo" className="logo" />
          <span className="logo-text">ConvoCue AI</span>
        </Link>
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? 'X' : '≡'}
      </button>
      <nav className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        <NavContent />
      </nav>
    </header>
  );
}

export default Header;
